import React, { Children, cloneElement } from 'react';
import Skeleton from 'react-loading-skeleton';

const TimelineSkeleton: React.FC = ({ children }) => {
  return (
    <>
      {Children.map(children, (child) => {
        if (!React.isValidElement(child)) return null;

        return cloneElement(child, {
          title: <Skeleton width="150px" height="14px" />,
          icon: <Skeleton width="40px" height="40px" circle />,
          status: 'PENDING',
          children: undefined,
          description: <Skeleton width="80%" height="14px" />
        });
      })}
    </>
  );
};

export default TimelineSkeleton;
